// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YQpQ","selected":"styles_selected__2beII"};